<div class="filter-area-root">
  <owl-carousel-o *ngIf="isCarousel" [options]="customOptions">
    <ng-container *ngFor="let element of chipContents; let i = index">
      <ng-template carouselSlide>
        <app-chip 
          id="lnr-chip-filter-{{element.value}}-{{i}}"
          content
          small 
          gray="{{isGray}}"
          grayBlue="{{isGrayBlue}}"
          icon="{{element.icon}}"
          iconAfter="{{element.iconAfter}}" 
          (selectFilterClick)="selectFilter(element)" 
          active="{{element.isActive}}"
          [options]="element.options"
          (optionClickAction)="selectChipOption($event, element)">
          {{element.value}}
        </app-chip>
      </ng-template>
    </ng-container >
  </owl-carousel-o>
  <div *ngIf="!isCarousel" class="filters">
    <ng-container *ngFor="let element of chipContents; let i = index">
      <app-chip 
      id="lnr-chip-filter-{{element.value}}-{{i}}"
      content
      small 
      gray="{{isGray}}"
      grayBlue="{{isGrayBlue}}"
      icon="{{element.icon}}"
      iconAfter="{{element.iconAfter}}" 
      (selectFilterClick)="selectFilter(element)" 
      active="{{element.isActive}}"
      [options]="element.options"
      (optionClickAction)="selectChipOption($event, element)">
      {{element.value}}
    </app-chip>
    </ng-container >
  </div>
</div>
